/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetContactSummaryDto
 */
export interface GetContactSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof GetContactSummaryDto
     */
    id: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetContactSummaryDto
     */
    contactType: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetContactSummaryDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactSummaryDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetContactSummaryDto interface.
 */
export function instanceOfGetContactSummaryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "contactType" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetContactSummaryDtoFromJSON(json: any): GetContactSummaryDto {
    return GetContactSummaryDtoFromJSONTyped(json, false);
}

export function GetContactSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contactType': GetDictionaryDtoFromJSON(json['contactType']),
        'email': json['email'],
        'active': json['active'],
    };
}

export function GetContactSummaryDtoToJSON(value?: GetContactSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'contactType': GetDictionaryDtoToJSON(value.contactType),
        'email': value.email,
        'active': value.active,
    };
}

